import { List, Record } from 'immutable';
import {
  FAILURE,
  HISTORY_FAILURE,
  HISTORY_SUCCESS,
  PIN_FAILURE,
  RESTRICTIONS_AGREED,
  SAVE_AMOUNT,
  SUCCESS,
  VIEW_ENTER
} from './actions';

const InitialState = new Record({
  step: '',
  amount: '',
  history: new List(),
  historyLoaded: false,
  pendingWithdrawal: false
});

const HistoryItem = new Record({
  id: '',
  status: '',
  datetime: '',
  amount: ''
});

const mapHistory = item => new HistoryItem({
  id: item.id,
  status: item.status,
  datetime: item.datetime,
  amount: item.amount
});

const isPending = items => items && items.length && items[0].status === 'PENDING';

export const STEP_RESTRICTIONS = 'restrictions';
export const STEP_AMOUNT = 'amount-form';
export const STEP_PIN = 'pin-form';
export const STEP_SUCCESS = 'success';

export default (state = new InitialState(), action) => {
  switch (action.type) {
    case VIEW_ENTER: {
      return state
        .set('step', STEP_RESTRICTIONS)
        .set('historyLoaded', false)
        .set('pendingWithdrawal', false);
    }
    case RESTRICTIONS_AGREED:
    case FAILURE: {
      return state
        .set('step', STEP_AMOUNT)
        .set('amount', '');
    }
    case SAVE_AMOUNT: {
      return state
        .set('step', STEP_PIN)
        .set('amount', action.amount);
    }
    case PIN_FAILURE: {
      return state
        .set('step', STEP_PIN);
    }
    case SUCCESS: {
      return state
        .set('step', STEP_SUCCESS)
        .set('amount', action.amount);
    }
    case HISTORY_SUCCESS: {
      return state
        .set('history', new List(action.history.map(mapHistory)))
        .set('historyLoaded', true)
        .set('pendingWithdrawal', isPending(action.history));
    }
    case HISTORY_FAILURE: {
      return state
        .set('history', new List([]))
        .set('historyLoaded', true)
        .set('pendingWithdrawal', false);
    }
    default: {
      return state;
    }
  }
};
